import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IApplicationContext, TApplicationContextCustom } from '../../../shared/types/applicationContext';

export function createContext(): IApplicationContext {
  const config = getConfig();

  return {
    config: getConfig(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    custom: config.getStrict<TApplicationContextCustom>('applicationContext.custom'),
  };
}
